import { render, staticRenderFns } from "./MyAppraisals.vue?vue&type=template&id=b92e4534&scoped=true"
import script from "./MyAppraisals.vue?vue&type=script&lang=js"
export * from "./MyAppraisals.vue?vue&type=script&lang=js"
import style0 from "./MyAppraisals.vue?vue&type=style&index=0&id=b92e4534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92e4534",
  null
  
)

export default component.exports